(() => {
  if (window.codebrwnProductInitialized) return;
  window.codebrwnProductInitialized = true;

  const initGallery = (root) => {
    const image = root.querySelector('[data-cb-main-image]');
    const mainMedia = root.querySelector('.cb-pdp__main-media');
    const zoom = root.querySelector('[data-cb-zoom]');
    const galleryControls = root.querySelector('.cb-pdp__gallery-controls');
    const previousButton = root.querySelector('[data-cb-gallery-previous]');
    const nextButton = root.querySelector('[data-cb-gallery-next]');
    const thumbs = Array.from(root.querySelectorAll('[data-cb-thumb]'));
    const lightbox = root.querySelector('[data-cb-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-cb-lightbox-image]');
    const lightboxThumbs = Array.from(lightbox?.querySelectorAll('[data-cb-lightbox-thumb]') || []);
    const lightboxCounter = lightbox?.querySelector('[data-cb-lightbox-counter]');
    if (!image || !thumbs.length) return;

    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    if (zoom) zoom.dataset.mediaId = thumbs[activeIndex]?.dataset.mediaId || '';
    if (galleryControls) galleryControls.hidden = thumbs.length < 2;

    thumbs.forEach((thumb) => {
      if (!thumb.dataset.imageSrc) return;
      const preload = new Image();
      preload.src = thumb.dataset.imageSrc;
      preload.srcset = thumb.dataset.imageSrcset || '';
    });

    const selectImage = (index, direction) => {
      const previousIndex = activeIndex;
      activeIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[activeIndex];
      const swipeDirection = direction || (activeIndex > previousIndex ? 1 : -1);

      image.src = thumb.dataset.imageSrc;
      image.srcset = thumb.dataset.imageSrcset;
      image.alt = thumb.dataset.imageAlt || '';

      if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
        image.classList.remove('cb-pdp__main-image--swipe-next', 'cb-pdp__main-image--swipe-previous');
        void image.offsetWidth;
        image.classList.add(swipeDirection > 0 ? 'cb-pdp__main-image--swipe-next' : 'cb-pdp__main-image--swipe-previous');
      }

      if (zoom) zoom.dataset.mediaId = thumb.dataset.mediaId || '';
      thumbs.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
    };

    const renderLightbox = (index) => {
      if (!lightboxImage || !lightboxThumbs.length) return;
      activeIndex = (index + lightboxThumbs.length) % lightboxThumbs.length;
      const thumb = lightboxThumbs[activeIndex];
      lightboxImage.src = thumb.dataset.imageSrc;
      lightboxImage.alt = thumb.dataset.imageAlt || '';
      lightboxThumbs.forEach((item, itemIndex) => {
        const isActive = itemIndex === activeIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      if (lightboxCounter) lightboxCounter.textContent = `${activeIndex + 1} / ${lightboxThumbs.length}`;
      const mainIndex = thumbs.findIndex((item) => item.dataset.mediaId === thumb.dataset.mediaId);
      if (mainIndex >= 0) selectImage(mainIndex);
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        selectImage(index, index > activeIndex ? 1 : -1);
        const lightboxThumb = lightboxThumbs.find((item) => item.dataset.mediaId === thumb.dataset.mediaId);
        if (lightboxThumb?.dataset.imageSrc) {
          const preload = new Image();
          preload.src = lightboxThumb.dataset.imageSrc;
        }
      });
    });

    previousButton?.addEventListener('click', () => selectImage(activeIndex - 1, -1));
    nextButton?.addEventListener('click', () => selectImage(activeIndex + 1, 1));

    if (mainMedia && thumbs.length > 1) {
      let pointerId = null;
      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerDeltaX = 0;
      let isHorizontalDrag = false;

      const resetDraggedImage = () => {
        const fromTransform = image.style.transform || 'translateX(0)';
        const fromOpacity = image.style.opacity || '1';
        image.classList.remove('cb-pdp__main-image--dragging');
        image.style.removeProperty('transform');
        image.style.removeProperty('opacity');

        if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches && fromTransform !== 'translateX(0)') {
          image.animate(
            [{ transform: fromTransform, opacity: fromOpacity }, { transform: 'translateX(0)', opacity: 1 }],
            { duration: 180, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }
          );
        }
      };

      const completeDraggedSlide = (direction) => {
        const startOffset = pointerDeltaX;
        const startOpacity = image.style.opacity || '1';
        image.classList.remove('cb-pdp__main-image--dragging');
        image.style.removeProperty('transform');
        image.style.removeProperty('opacity');

        const finish = () => selectImage(activeIndex + direction, direction);
        if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
          finish();
          return;
        }

        const outgoing = image.animate(
          [
            { transform: `translateX(${startOffset}px)`, opacity: startOpacity },
            { transform: `translateX(${direction * mainMedia.clientWidth}px)`, opacity: 0 },
          ],
          { duration: 120, easing: 'ease-out', fill: 'none' }
        );
        outgoing.finished.then(finish).catch(finish);
      };

      mainMedia.addEventListener(
        'pointerdown',
        (event) => {
          if (event.button !== 0 || event.target.closest('button, a')) return;
          pointerId = event.pointerId;
          pointerStartX = event.clientX;
          pointerStartY = event.clientY;
          pointerDeltaX = 0;
          isHorizontalDrag = false;
          mainMedia.setPointerCapture?.(pointerId);
          image.classList.remove('cb-pdp__main-image--swipe-next', 'cb-pdp__main-image--swipe-previous');
        }
      );

      mainMedia.addEventListener(
        'pointermove',
        (event) => {
          if (pointerId !== event.pointerId) return;

          const deltaX = event.clientX - pointerStartX;
          const deltaY = event.clientY - pointerStartY;
          if (!isHorizontalDrag) {
            if (Math.abs(deltaY) > Math.abs(deltaX)) return;
            if (Math.abs(deltaX) < 8) return;
            isHorizontalDrag = true;
          }

          event.preventDefault();
          pointerDeltaX = Math.max(-mainMedia.clientWidth * 0.85, Math.min(mainMedia.clientWidth * 0.85, deltaX));
          image.classList.add('cb-pdp__main-image--dragging');
          image.style.transform = `translateX(${pointerDeltaX}px)`;
          image.style.opacity = String(Math.max(0.45, 1 - (Math.abs(pointerDeltaX) / mainMedia.clientWidth) * 0.45));
        }
      );

      mainMedia.addEventListener(
        'pointerup',
        (event) => {
          if (pointerId !== event.pointerId) return;

          const deltaX = event.clientX - pointerStartX;
          const deltaY = event.clientY - pointerStartY;
          const swipeThreshold = Math.max(40, mainMedia.clientWidth * 0.12);

          pointerId = null;
          mainMedia.releasePointerCapture?.(event.pointerId);

          if (!isHorizontalDrag || Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) <= Math.abs(deltaY)) {
            resetDraggedImage();
            return;
          }
          completeDraggedSlide(deltaX < 0 ? 1 : -1);
        }
      );

      mainMedia.addEventListener(
        'pointercancel',
        (event) => {
          if (pointerId !== event.pointerId) return;
          pointerId = null;
          resetDraggedImage();
        }
      );
    }

    if (!zoom || !lightbox) return;

    zoom.addEventListener('click', () => {
      const selectedIndex = lightboxThumbs.findIndex((thumb) => thumb.dataset.mediaId === zoom.dataset.mediaId);
      renderLightbox(selectedIndex >= 0 ? selectedIndex : 0);
      if (!lightbox.open) lightbox.showModal();
      document.body.classList.add('cb-product-lightbox-open');
    });

    lightbox.querySelector('[data-cb-lightbox-close]')?.addEventListener('click', () => lightbox.close());
    lightbox.querySelector('[data-cb-lightbox-previous]')?.addEventListener('click', () => renderLightbox(activeIndex - 1));
    lightbox.querySelector('[data-cb-lightbox-next]')?.addEventListener('click', () => renderLightbox(activeIndex + 1));
    lightboxThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => renderLightbox(index)));

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });

    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') renderLightbox(activeIndex - 1);
      if (event.key === 'ArrowRight') renderLightbox(activeIndex + 1);
    });

    lightbox.addEventListener('close', () => document.body.classList.remove('cb-product-lightbox-open'));
  };

  const readRecentlyViewed = () => {
    try {
      const stored = JSON.parse(localStorage.getItem('codebrwnRecentlyViewed') || '[]');
      if (!Array.isArray(stored)) return [];
      return stored.filter((item) => typeof item?.handle === 'string' && item.handle.length > 0);
    } catch {
      return [];
    }
  };

  const initRecentlyViewed = (root) => {
    const data = root.querySelector('[data-cb-current-product-json]');
    if (!data) return;

    const key = 'codebrwnRecentlyViewed';
    const current = JSON.parse(data.textContent);
    const handles = [...new Set([current.handle, ...readRecentlyViewed().map((item) => item.handle)])];
    try {
      localStorage.setItem(key, JSON.stringify(handles.slice(0, 8).map((handle) => ({ handle }))));
    } catch {
      return;
    }
  };

  const renderRecentlyViewed = async (root) => {
    const grid = root.querySelector('[data-cb-recent-grid]');
    if (!grid) return;

    const currentHandle = root.dataset.currentHandle;
    const fallbackCards = Array.from(grid.querySelectorAll('[data-cb-recent-fallback]'));
    const products = readRecentlyViewed()
      .filter((item) => item.handle !== currentHandle)
      .slice(0, 5);

    if (!products.length) return;

    const results = await Promise.allSettled(products.map(async ({ handle }) => {
      const productUrl = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}`;
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('section_id', 'codebrwn-recent-card');
      const response = await fetch(url, { cache: 'no-store', signal: AbortSignal.timeout(8000) });
      if (!response.ok) return null;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      return doc.querySelector('[data-cb-recent-card]');
    }));
    if (!root.isConnected) return;
    const viewedCards = results.filter((result) => result.status === 'fulfilled' && result.value)
      .map((result) => result.value);
    const viewedHandles = viewedCards.map((card) => card.dataset.productHandle);
    const remainingFallbackCards = fallbackCards
      .filter((card) => card.dataset.productHandle !== currentHandle)
      .filter((card) => !viewedHandles.includes(card.dataset.productHandle));

    if (viewedCards.length) grid.replaceChildren(...[...viewedCards, ...remainingFallbackCards].slice(0, 5));
  };

  const initStickyPurchase = (root) => {
    const purchase = root.querySelector('.cb-pdp__purchase-bar');
    const aPlus = root.querySelector('.cb-pdp__a-plus');
    const info = root.querySelector('.cb-pdp__info');
    if (!purchase || !info) return;

    const update = () => {
      const infoRect = info.getBoundingClientRect();
      const threshold = aPlus ? aPlus.getBoundingClientRect().top : infoRect.bottom;
      const shouldDock = threshold <= 120 && window.scrollY > 16;

      root.style.setProperty('--cb-purchase-left', `${Math.max(infoRect.left, 0)}px`);
      root.style.setProperty('--cb-purchase-width', `${infoRect.width}px`);
      purchase.classList.toggle('is-fixed', shouldDock);
      document.body.classList.toggle('cb-pdp-dock-active', shouldDock);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  };

  const initPurchaseVariant = (root) => {
    const summary = root.querySelector('[data-cb-purchase-variant]');
    const price = root.querySelector('[data-cb-purchase-price]');
    if (!price) return;

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, html, variant } }) => {
      if (String(sectionId) !== root.dataset.section) return;
      if (summary) summary.textContent = variant?.title || '';

      const priceNode = html.getElementById(`price-${sectionId}`);
      const isSale = priceNode?.querySelector('.price--on-sale');
      const amount = priceNode?.querySelector(isSale ? '.price-item--sale' : '.price__regular .price-item--regular');
      if (amount) price.textContent = amount.textContent.trim();
    });
  };

  const initSizeGuide = (root) => {
    const guide = root.querySelector('[data-cb-size-guide]');
    if (!guide) return;

    const drawer = guide.querySelector('.cb-size-guide__drawer');
    const openButtons = root.querySelectorAll('[data-cb-size-guide-open]');
    const closeButtons = guide.querySelectorAll('[data-cb-size-guide-close]');
    const tabs = guide.querySelectorAll('[data-cb-size-tab]');
    const panels = guide.querySelectorAll('.cb-size-guide__panel');
    const unitControl = guide.querySelector('[data-cb-size-unit-control]');
    const unitButtons = guide.querySelectorAll('[data-cb-size-unit]');
    const rows = guide.querySelectorAll('[data-cb-size-row]');
    const addButton = guide.querySelector('[data-cb-size-guide-add]');
    let selectedSize = '';

    const findSizeControl = (size) => {
      const normalized = size.trim().toLowerCase();
      const inputs = Array.from(root.querySelectorAll('input[data-option-name], select[name^="options["]'));

      return inputs.find((input) => {
        const optionName = input.dataset.optionName || input.name || '';
        if (!optionName.toLowerCase().includes('size')) return false;
        if (input.tagName === 'SELECT') {
          return Array.from(input.options).some((option) => option.value.trim().toLowerCase() === normalized);
        }
        return input.value.trim().toLowerCase() === normalized;
      });
    };

    const applySize = (size) => {
      const control = findSizeControl(size);
      if (!control) return;

      if (control.tagName === 'SELECT') {
        const match = Array.from(control.options).find((option) => option.value.trim().toLowerCase() === size.trim().toLowerCase());
        if (match) {
          control.value = match.value;
          control.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      if (!control.disabled && !control.classList.contains('disabled')) {
        control.click();
      }
    };

    const openGuide = () => {
      guide.hidden = false;
      document.body.classList.add('cb-size-guide-open');
      drawer?.focus();
    };

    const closeGuide = () => {
      guide.hidden = true;
      document.body.classList.remove('cb-size-guide-open');
    };

    const setUnit = (unit) => {
      unitButtons.forEach((button) => button.classList.toggle('is-active', button.dataset.cbSizeUnit === unit));
      guide.querySelectorAll('[data-inch-value]').forEach((cell) => {
        const value = cell.dataset.inchValue;
        const numericValue = Number.parseFloat(value);
        if (unit === 'cm' && Number.isFinite(numericValue)) {
          cell.textContent = (numericValue * 2.54).toFixed(1);
        } else {
          cell.textContent = value || '-';
        }
      });
    };

    openButtons.forEach((button) => button.addEventListener('click', openGuide));
    closeButtons.forEach((button) => button.addEventListener('click', closeGuide));

    guide.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeGuide();
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((button) => {
          const isActive = button === tab;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const isActive = panel.id === tab.getAttribute('aria-controls');
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
        if (unitControl) unitControl.hidden = tab.dataset.cbSizeTab !== 'chart';
      });
    });

    unitButtons.forEach((button) => {
      button.addEventListener('click', () => setUnit(button.dataset.cbSizeUnit));
    });

    rows.forEach((row) => {
      row.addEventListener('click', () => {
        selectedSize = row.dataset.sizeValue || '';
        rows.forEach((item) => item.classList.toggle('is-selected', item === row));
        applySize(selectedSize);
      });
    });

    addButton?.addEventListener('click', () => {
      if (selectedSize) applySize(selectedSize);
      closeGuide();
      root.querySelector('product-form form button[type="submit"]')?.click();
    });

    setUnit('in');
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-codebrwn-pdp]').forEach((root) => {
      initGallery(root);
      initRecentlyViewed(root);
      initStickyPurchase(root);
      initPurchaseVariant(root);
      initSizeGuide(root);
    });
    document.querySelectorAll('[data-codebrwn-recently-viewed]').forEach(renderRecentlyViewed);
  });
})();
